import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WarehouseValueReportPage } from "src/components/views/erp/warehouse/reports/WarehouseValueReportPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/reports/warehouseValue")({
	staticData: { title: i18n.t("warehouse_value_report"), legacyViewKey: "warehouseValueReportPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <WarehouseValueReportPage />;
}
